// AwardsCarousel.js
import React from 'react';
import useContentfulAwards from '../contentfulAwards';

const AwardsTicker = () => {
    const images = useContentfulAwards();

    if (!images || !images.length) {
        return <div>Loading...</div>;
    }

    const awards = images.map((url, index) => ({
        href: "https://holbornassets.com/news/holborn-scoops-8-awards-international-investment-2022/",
        src: url,
        alt: `Award ${index + 1}`,
        style: { position: 'relative', top: index < 7 ? '20px' : '0px' }
    }));

    return (
        <div className="image-ticker awards">
            <ul>
                {awards.map((award, index) => (
                    <li key={index}>
                        <a href={award.href} target="_blank" rel="noopener noreferrer">
                            <img
                                src={award.src}
                                alt={award.alt}
                                className="d-block w-100"
                                style={award.style}
                            />
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AwardsTicker;